import { makeVar } from '@apollo/client/cache';
import { User } from 'models/user';

export const currentUserVar = makeVar<User>({} as User);
